import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import config from "../../config";

const EmailRequired = ({ children }) => {
  const user = config.user;
  const location = useLocation();
  
  // Don't redirect if already on profile page (to avoid infinite loops)
  if (location.pathname === "/profile") {
    return children;
  }
  
  // If user is a customer or seller and doesn't have email, redirect to profile edit
  if (user && (user.type === "customer" || user.type === "seller") && user.email === null) {
    return <Navigate to="/profile?edit=true" replace />;
  }
  
  // Otherwise, render the protected component
  return children;
};

export default EmailRequired;
